export const unidadesInitialState = {
  unidades: [],
  novaUnidade: [],
  unidadeRemovida: [],
  unidade: [],
  unidadeEditada: [],
};
